export const isPromiseRejected = <T>(
  promise: PromiseSettledResult<T>,
): promise is PromiseRejectedResult => promise.status === 'rejected'
